const errorCodes = {
  KNOX_MANAGE_SLM_KEY_IS_INVALID:
    'The SLM key you have provided is invalid. Please use a valid SLM key.',
  KNOX_MANAGE_USER_ID_IS_INVALID: 'You have used invalid characters in your User ID.',
  KNOX_MANAGE_ORG_NAME_IS_INVALID:
    'Your Organizational Name cannot contain any spaces or special characters.',
  KNOX_MANAGE_ORG_NAME_NOT_ALLOWED: 'The Organizational Name you have chosen is not allowed.',
  KNOX_MANAGE_USER_ID_SUPPORT_NOT_ALLOWED: 'You cannot use "support" as your User ID.',
  KNOX_MANAGE_USER_CANNOT_REGISTER: 'Knox Manage user cannot be registered.',
  KNOX_MANAGE_USER_ALREADY_REGISTERED: 'You already have a Knox Manage tenant.',
  KNOX_MANAGE_KS_KEY_IS_REQUIRED:
    'Unable to generate Knox Manage trial license key. Please try again later.',
  UNRECOGNIZED_LICENSE_KEY: 'License key is unrecognized.',
  AMS_INVALID_USER_SESSION: 'Invalid user session.'
}

export const getMessageFromErrorCode = (errorCode, defaultMsg = undefined) => {
  return errorCodes[errorCode]
    ? errorCodes[errorCode]
    : defaultMsg || 'An unexpected error has occurred.'
}

//NOTE:  useTranslation() hook should work here when translations are needed
